const pad = (value) => String(value).padStart(2, '0');

export const localInputToUtcIso = (value) => {
  if (!value) {
    return '';
  }

  const localDate = new Date(value);
  return Number.isNaN(localDate.getTime()) ? '' : localDate.toISOString();
};

export const utcToLocalInputValue = (value) => {
  if (!value) {
    return '';
  }

  const utcDate = new Date(value);
  if (Number.isNaN(utcDate.getTime())) {
    return '';
  }

  return `${utcDate.getFullYear()}-${pad(utcDate.getMonth() + 1)}-${pad(utcDate.getDate())}T${pad(utcDate.getHours())}:${pad(utcDate.getMinutes())}`;
};